import { render, staticRenderFns } from "./FlavorDeviceSpecification.vue?vue&type=template&id=8f0fe666&scoped=true&"
import script from "./FlavorDeviceSpecification.vue?vue&type=script&lang=js&"
export * from "./FlavorDeviceSpecification.vue?vue&type=script&lang=js&"
import style0 from "./FlavorDeviceSpecification.vue?vue&type=style&index=0&id=8f0fe666&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0fe666",
  null
  
)

export default component.exports